import React from "react";
import PhoneInput from "react-phone-input-2";

export default function CustomPhoneInput({
  label,
  touched,
  error,
  countryCode,
  phoneNumber,
  setFieldValue,
  placeholder,
  disabled,
}) {
  return (
    <div className="common-modal-field">
      <label>{label}</label>
      <PhoneInput
        disabled={disabled}
        enableSearch={true}
        country="ca"
        value={`${countryCode}${phoneNumber}`}
        placeholder={placeholder || "Enter your phone number"}
        onChange={(value, data) => {
          const rawPhone = value
            .replace(/[^0-9]+/g, "")
            .slice(data?.dialCode?.length);
          setFieldValue("phoneNumber", rawPhone);
          setFieldValue("countryCode", data.dialCode);
        }}
      />
      {touched && error && (
        <p style={{ color: "red", marginBottom: 0 }}>{error}</p>
      )}
    </div>
  );
}
